/* ovs-grid unique-handles 2026-09-11 */
(function () {
  var ATTRS = ['data-ovs-po-handle', 'data-ovs-mk-handle', 'data-product-handle'];

  function productHandle(item) {
    var i;
    var name;
    var value;
    var nested;
    var href;
    var match;

    for (i = 0; i < ATTRS.length; i += 1) {
      name = ATTRS[i];
      value = item.getAttribute(name);
      if (value) {
        return value;
      }
      nested = item.querySelector('[' + name + ']');
      if (nested) {
        value = nested.getAttribute(name);
        if (value) {
          return value;
        }
      }
    }

    href = '';
    nested = item.querySelector('a[href*="/products/"]');
    if (nested) {
      href = nested.getAttribute('href') || '';
    }
    match = href.match(/\/products\/([^/?#]+)/);
    return match && match[1] ? decodeURIComponent(match[1]) : '';
  }

  function isShown(item) {
    return !item.hidden && !item.classList.contains('hidden') && item.getAttribute('aria-hidden') !== 'true';
  }

  function gridNodes() {
    return Array.from(
      new Set([].concat(Array.from(document.querySelectorAll('#product-grid')), Array.from(document.querySelectorAll('ul.product-grid')))),
    );
  }

  function keepNodeForHandle(items) {
    var keep = new Map();
    items.forEach(function (item) {
      var handle = productHandle(item);
      if (handle === '' || keep.has(handle) || !isShown(item)) {
        return;
      }
      keep.set(handle, item);
    });
    items.forEach(function (item) {
      var handle = productHandle(item);
      if (handle === '' || keep.has(handle)) {
        return;
      }
      keep.set(handle, item);
    });
    return keep;
  }

  function dedupeGrid(grid) {
    var items = Array.from(grid.querySelectorAll(':scope > .grid__item'));
    var keep = keepNodeForHandle(items);
    items.forEach(function (item) {
      var handle = productHandle(item);
      if (handle === '') {
        return;
      }
      if (keep.get(handle) !== item) {
        item.remove();
      }
    });
  }

  var running = false;

  function dedupeAll() {
    if (running) {
      return;
    }
    running = true;
    try {
      gridNodes().forEach(dedupeGrid);
    } finally {
      running = false;
    }
  }

  function observeGrids() {
    gridNodes().forEach(function (grid) {
      if (grid.dataset.ovsDedupeObserved === '1') {
        return;
      }
      grid.dataset.ovsDedupeObserved = '1';
      new MutationObserver(function () {
        window.requestAnimationFrame(dedupeAll);
      }).observe(grid, { childList: true });
    });
  }

  window.OVS_DEDUP_PRODUCT_GRIDS = dedupeAll;

  document.addEventListener('ovs:product-grid-updated', function () {
    dedupeAll();
    observeGrids();
  });

  document.addEventListener('DOMContentLoaded', function () {
    dedupeAll();
    observeGrids();
  });

  if (document.readyState !== 'loading') {
    dedupeAll();
    observeGrids();
  }
})();
